import _typeof from 'babel-runtime/helpers/typeof';
import _Symbol$for from 'babel-runtime/core-js/symbol/for';
import _Symbol from 'babel-runtime/core-js/symbol';
import { Component, cloneElement, h, options, render } from 'preact';

var map = function map(children, fn, ctx) {
  if (children == null) {
    return children;
  }

  children = toArray(children);

  if (ctx && ctx !== children) {
    fn = fn.bind(ctx);
  }

  return children.map(fn);
};

var forEach = function forEach(children, fn, ctx) {
  if (children == null) {
    return;
  }

  children = toArray(children);
  if (ctx && ctx !== children) {
    fn = fn.bind(ctx);
  }

  children.forEach(fn);
};

var count = function count(children) {
  return children && children.length || 0;
};

var only = function only(children) {
  children = toArray(children);

  if (children.length !== 1) {
    throw new Error('Children.only() expects only one child.');
  }

  return children[0];
};

var toArray = function toArray(children) {
  return children == null ? [] : [].concat(children);
};

var Children = Object.freeze({
	map: map,
	forEach: forEach,
	count: count,
	only: only,
	toArray: toArray
});

var hasSymbol = typeof _Symbol === 'function' && _Symbol$for;
var createElement = h;
var VNodeCtor = h("a", null).constructor;
var REACT_ELEMENT_TYPE = hasSymbol ? _Symbol$for('react.element') : 0xeac7;
var REACT_FORWARD_REF_TYPE = hasSymbol ? _Symbol$for('react.forward_ref') : 0xead0;

// React VNode has the `type` property instead of `nodeName`
Object.defineProperty(VNodeCtor.prototype, "type", {
  get: function get() {
    return this.nodeName;
  },
  set: function set(v) {
    this.nodeName = v;
  },

  configurable: true
});

// React VNode has the `prop` property instead of `attributes`
Object.defineProperty(VNodeCtor.prototype, "props", {
  get: function get() {
    return this.attributes;
  },
  set: function set(v) {
    this.attributes = v;
  },

  configurable: true
});

var isValidElement = function isValidElement(maybeElement) {
  return !!maybeElement && maybeElement instanceof VNodeCtor;
};

var oldVnode = options.vnode;

/**
 * Compatibility with Function as Child Component. react-router requires this.
 *
 * React exports sigle-children as-is, instead of wrapping them in an array as
 * preact does. We do this for single-element functions to suppport FaCC.
 */
options.vnode = function (vnode) {
  if (vnode.children.length === 1 && typeof vnode.children[0] === "function") {
    vnode.children = vnode.children[0];
  }

  if (typeof oldVnode === "function") {
    oldVnode(vnode);
  }
};

function findDOMNode(component) {
  return component && component.base;
}

function isValidElementType(element) {
  // TODO: More types
  return typeof element === "string" || typeof element === "function";
}

// React 8 does not support anything pretty much
function isNotNode(element) {
  return false;
}

function typeOf(element) {
  // Preact 8 does not support anything really besides plain elements
  if ((typeof element === "undefined" ? "undefined" : _typeof(element)) === "object") {
    return REACT_ELEMENT_TYPE;
  }

  return undefined;
}

function isElement(element) {
  return (typeof element === "undefined" ? "undefined" : _typeof(element)) === "object" && element !== null;
}

var index = {
  Children: Children,
  Component: Component,
  cloneElement: cloneElement,
  createElement: createElement,
  findDOMNode: findDOMNode,
  h: h,
  isElement: isElement,
  isConcurrentMode: isNotNode,
  isContextConsumer: isNotNode,
  isContextProvider: isNotNode,
  isForwardRef: isNotNode,
  isFragment: isNotNode,
  isLazy: isNotNode,
  isMemo: isNotNode,
  isPortal: isNotNode,
  isProfiler: isNotNode,
  isStrictMode: isNotNode,
  isSuspense: isNotNode,
  ForwardRef: REACT_FORWARD_REF_TYPE,
  isValidElement: isValidElement,
  isValidElementType: isValidElementType,
  options: options,
  render: render,
  typeOf: typeOf
};

export { Children, Component, cloneElement, createElement, findDOMNode, h, isElement, isNotNode as isConcurrentMode, isNotNode as isContextConsumer, isNotNode as isContextProvider, isNotNode as isForwardRef, isNotNode as isFragment, isNotNode as isLazy, isNotNode as isMemo, isNotNode as isPortal, isNotNode as isProfiler, isNotNode as isStrictMode, isNotNode as isSuspense, REACT_FORWARD_REF_TYPE as ForwardRef, isValidElement, isValidElementType, options, render, typeOf };
export default index;
//# sourceMappingURL=index.es2015.js.map
